import { OperationTimeConsModel } from "./operation-time-cons.model";


export class StyleOperationsTimeConsModel {
    styleId: string;
    styleDesc: string;
    operations: string[]; // will be in the planned op order
    operationLevelTime: OperationTimeConsModel[];

    constructor(styleId: string,
        styleDesc: string,
        operations: string[],
        operationLevelTime: OperationTimeConsModel[]
        ) {
            this.styleId = styleId;
            this.styleDesc = styleDesc;
            this.operations = operations;
            this.operationLevelTime = operationLevelTime;
    }
}
